var map = {
	"./add-to-cart.svg": 671,
	"./bandwidth.svg": 267,
	"./cash.svg": 468,
	"./chatgpt.svg": 609,
	"./circular-arrow.svg": 255,
	"./clock.svg": 997,
	"./coin.svg": 89,
	"./coupon.svg": 102,
	"./discount.svg": 349,
	"./dot-arrow.svg": 283,
	"./dot-right-arrow.svg": 45,
	"./down-arrow.svg": 481,
	"./error.svg": 687,
	"./eye-off.svg": 10,
	"./eye-show.svg": 517,
	"./hard-drive.svg": 151,
	"./help.svg": 769,
	"./information.svg": 882,
	"./letter-open.svg": 718,
	"./magnifire.svg": 525,
	"./midjourney.svg": 13,
	"./numbers.svg": 601,
	"./ok-mark.svg": 766,
	"./pay-per-click.svg": 685,
	"./pay.svg": 430,
	"./perplexity.svg": 46,
	"./poe.svg": 814,
	"./processor.svg": 73,
	"./ram.svg": 360,
	"./right-arrow.svg": 857,
	"./stopwatch.svg": 792,
	"./triangular-arrowhead.svg": 531,
	"./waiting-list.svg": 40,
	"./wallet.svg": 740,
	"./warning-circle.svg": 650,
	"./warning-triangle.svg": 758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 566;